/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import Compiled, { MultiValueContainer as CompiledMultiValueContainer, multiValueCSS as CompiledMultiValueCSS, MultiValueLabel as CompiledMultiValueLabel, multiValueLabelCSS as CompiledMultiValueLabelCSS, MultiValueRemove as CompiledMultiValueRemove, multiValueRemoveCSS as CompiledMultiValueRemoveCSS } from '../compiled/components/multi-value';
export var multiValueCSS = function multiValueCSS(props) {
  return CompiledMultiValueCSS();
};
export var multiValueLabelCSS = function multiValueLabelCSS(props) {
  return CompiledMultiValueLabelCSS();
};
export var multiValueRemoveCSS = function multiValueRemoveCSS(props) {
  return CompiledMultiValueRemoveCSS();
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MultiValueContainer = function MultiValueContainer(props) {
  return /*#__PURE__*/React.createElement(CompiledMultiValueContainer, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MultiValueLabel = function MultiValueLabel(props) {
  return /*#__PURE__*/React.createElement(CompiledMultiValueLabel, props);
};
export function MultiValueRemove(props) {
  return /*#__PURE__*/React.createElement(CompiledMultiValueRemove, props);
}
var MultiValue = function MultiValue(props) {
  return /*#__PURE__*/React.createElement(Compiled, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default MultiValue;